import Vue from 'vue'

export default {
  listarIteracao: () => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarIteracao{
            id
            data
            publicacao{
              id
              titulo
              texto
              data
              ativa
              publicado
              grupo{
                descricao
              }
              autor{
                nome
              }
              editorial{
                titulo
                descricao
                data
                publicado
              }
            }
            cliente{
              id
              nome
              plataforma
            }
            tipo_iteracao{
              id
              descricao
            }
            ativo
          }
        }`
      }
    })
  },
  listarIteracaoByPublicacao: (publicacao_id) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarIteracao(publicacao_id: ${publicacao_id}){
            id
            data
            publicacao{
              id
              titulo
              texto
              data
              ativa
              publicado
              grupo{
                descricao
              }
              autor{
                nome
              }
              editorial{
                titulo
                descricao
                data
                publicado
              }
            }
            cliente{
              id
              nome
              plataforma
            }
            tipo_iteracao{
              id
              descricao
            }
            ativo
          }
        }`
      }
    })
  },
  listarIteracaoByCliente: (cliente_id) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarIteracao(cliente_id: ${cliente_id}){
            id
            data
            publicacao{
              id
              titulo
              texto
              data
              ativa
              publicado
              grupo{
                descricao
              }
              autor{
                nome
              }
              editorial{
                titulo
                descricao
                data
                publicado
              }
            }
            cliente{
              id
              nome
              plataforma
            }
            tipo_iteracao{
              id
              descricao
            }
            ativo
          }
        }`
      }
    })
  },
  listarIteracaoByTipoIteracao: (tipo_iteracao_id) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarIteracao(tipo_iteracao_id: ${tipo_iteracao_id}){
            id
            data
            publicacao{
              id
              titulo
              texto
              data
              ativa
              publicado
              grupo{
                descricao
              }
              autor{
                nome
              }
              editorial{
                titulo
                descricao
                data
                publicado
              }
            }
            cliente{
              id
              nome
              plataforma
            }
            tipo_iteracao{
              id
              descricao
            }
            ativo
          }
        }`
      }
    })
  },
  criarIteracao: (iteracaoInput) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          criarIteracao(data:{
            iteracao_pai: ${iteracaoInput.iteracao_pai}
            data: "${iteracaoInput.data}"
            publicacao_id: ${iteracaoInput.publicacao_id}
            cliente_id: ${iteracaoInput.cliente_id}
            tipo_iteracao_id: ${iteracaoInput.tipo_iteracao_id}
            ativo: ${iteracaoInput.ativo}
          }){
            id
            data
            publicacao{
              id
              titulo
              texto
              data
              ativa
              publicado
              grupo{
                descricao
              }
              autor{
                nome
              }
              editorial{
                titulo
                descricao
                data
                publicado
              }
            }
            cliente{
              id
              nome
              plataforma
            }
            tipo_iteracao{
              id
              descricao
            }
            ativo
          }
        }`
      }
    })
  },
  atualizarIteracao: (iteracaoInput) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          atualizarIteracao(id: ${iteracaoInput.id}, data:{
            iteracao_pai: ${iteracaoInput.iteracao_pai}
            data: "${iteracaoInput.data}"
            publicacao_id: ${iteracaoInput.publicacao_id}
            cliente_id: ${iteracaoInput.cliente_id}
            tipo_iteracao_id: ${iteracaoInput.tipo_iteracao_id}
            ativo: ${iteracaoInput.ativo}
          }){
            id
            data
            publicacao{
              id
              titulo
              texto
              data
              ativa
              publicado
              grupo{
                descricao
              }
              autor{
                nome
              }
              editorial{
                titulo
                descricao
                data
                publicado
              }
            }
            cliente{
              id
              nome
              plataforma
            }
            tipo_iteracao{
              id
              descricao
            }
            ativo
          }
        }`
      }
    })
  },
  deletarIteracao: (iteracaoId) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          deletarIteracao(id: ${iteracaoId})
        }`
      }
    })
  },
  listarIteracaoSimplificado: (editorial_id, tipo_iteracao_id) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
          listarIteracaoSimplificado(editorial_id: ${editorial_id}, tipo_iteracao_id: ${tipo_iteracao_id}){
            tipo_iteracao{
              id
              descricao
            }
            quantidade
          }
        }`
      }
    })
  },
  registrarIteracaoAuto: (editorial_id, tipo_iteracao_id, quantidade) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          registrarIteracaoAuto(
            editorial_id: ${editorial_id},
            tipo_iteracao_id: ${tipo_iteracao_id},
            quantidade: ${quantidade})
        }`
      }
    })
  },
}
